import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import SiteProofLogo from '../../components/SiteProofLogo';
import SubscriptionReadOnlyBanner from '../../components/SubscriptionReadOnlyBanner';
import Icon from '../../components/AppIcon';

const WorkerWelcomeLanding = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const firstName = userProfile?.full_name?.split(' ')?.[0] || 'there';

  return (
    <>
      <Helmet>
        <title>Welcome to SiteProof</title>
      </Helmet>
      <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4">
        {/* Logo */}
        <div className="mb-8">
          <SiteProofLogo className="h-10" />
        </div>

        <div className="w-full max-w-md">
          <SubscriptionReadOnlyBanner className="mb-4" />
        </div>

        {/* Success card */}
        <div className="w-full max-w-md bg-surface border border-border rounded-2xl shadow-lg p-8 text-center">
          {/* Success icon */}
          <div className="flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mx-auto mb-5">
            <Icon name="CheckCircle" size={36} className="text-green-600" />
          </div>

          <h1 className="text-2xl font-bold text-text-primary mb-2">
            Welcome, {firstName}!
          </h1>
          <p className="text-text-secondary text-sm mb-6">
            Your account is set up and ready to go. You've been added to your company on SiteProof.
          </p>

          {/* What happens next */}
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 text-left mb-6">
            <p className="text-xs font-semibold text-blue-700 uppercase tracking-wide mb-3">
              What to expect next
            </p>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-blue-800">
                <Icon name="Clock" size={15} className="text-blue-500 mt-0.5 shrink-0" />
                Your admin will assign you to a site
              </li>
              <li className="flex items-start gap-2 text-sm text-blue-800">
                <Icon name="Bell" size={15} className="text-blue-500 mt-0.5 shrink-0" />
                You'll receive notifications when tasks or check-ins are assigned to you
              </li>
              <li className="flex items-start gap-2 text-sm text-blue-800">
                <Icon name="UserCircle" size={15} className="text-blue-500 mt-0.5 shrink-0" />
                You can update your profile at any time
              </li>
            </ul>
          </div>

          {/* Actions */}
          <div className="flex flex-col gap-3">
            <button
              onClick={() => navigate('/worker-today')}
              className="w-full bg-accent hover:bg-accent/90 text-white font-semibold text-sm py-3 rounded-xl transition-colors"
            >
              Go to My Dashboard
            </button>
            <button
              onClick={() => navigate('/profile-settings')}
              className="w-full bg-surface border border-border hover:bg-surface-hover text-text-primary font-medium text-sm py-3 rounded-xl transition-colors"
            >
              Update My Profile
            </button>
          </div>
        </div>

        <p className="mt-6 text-xs text-text-tertiary">
          Need help? Contact your site admin or visit{' '}
          <a href="https://site-proof.app" className="underline hover:text-text-secondary">
            site-proof.app
          </a>
        </p>
      </div>
    </>
  );
};

export default WorkerWelcomeLanding;
